/**
 * Where each gun's loot picture has the middle of its smallest enclosing circle, relative to the picture's own centre, in
 * picture pixels (measured on the pictures themselves). A gun lies on its bubble by that circle instead of by its box,
 * so a long magazine or stock hanging below no longer pushes the gun itself high and to one side of the bubble (the MPX
 * looked off centre), and the gun's far end is never closer to the ring than its size allows, at any turn. Guns not
 * listed are already centred. Re-measure after redrawing a gun's picture.
 */
export const LOOT_CENTRES: Readonly<Record<string, readonly [number, number]>> = {
    acr: [0, -7.2],
    aged_seedshot: [0, 4.5],
    ak47: [0, -9.6],
    aks74u: [0, -9.5],
    an94: [0, -8.8],
    arx160: [0, -9],
    as_val: [0, -6],
    aug: [0, -7],
    badlander: [0, 1.2],
    blr: [0, 4.8],
    cz600: [0, 4],
    cz75a: [-0.4, -4.5],
    deagle: [0, -2.2],
    death_ray: [0, 1.2],
    dp12: [0, -2.8],
    fn_fal: [0, -0.8],
    g17_scoped: [0.5, 1.8],
    g19: [0.5, 2],
    hp18: [0, -4],
    icicle_bow: [0, 4.8],
    l115a1: [0, 4.5],
    m16a2: [0, -5],
    m1895: [0, 1.2],
    m1_garand: [0, 2],
    m202: [0, -5.8],
    m3k: [0, 2],
    m590m: [0, -0.5],
    mcx_spear: [0, -10.5],
    mg36: [0, -1.5],
    mg5: [0, -7],
    micro_uzi: [-0.8, -11.4],
    mini14: [0, -1],
    mk18: [0, -0.5],
    model_89: [0, 1],
    mosin_nagant: [0, 1.2],
    mp5k: [-0.7, -10.1],
    mpx: [0, -6.2],
    negev: [0, -2.8],
    ots23: [0, -1],
    pk61: [0, -1.2],
    pp19: [0, -2.5],
    psm: [0.5, 1],
    revitalizer: [0, -0.8],
    rgs: [0, 3.8],
    rpk16: [0, -6.5],
    rpk74: [0, -11.8],
    rsh12: [-0.8, -1.2],
    saf200: [0, -11.5],
    seedshot: [0, 4.5],
    shak12: [0, -4],
    sks: [0, 1.5],
    ssg82: [0, 4],
    stoner_63: [0, -2],
    svu: [0, -2.5],
    tango_51: [0, 4.2],
    ulr338: [0, 1.2],
    usas12: [0, -2],
    vaccinator: [0, -11.7],
    vector: [0, -15.2],
    vepr12: [0, -4],
    vks: [0, 3],
    vss: [0, 4],
    yesaul: [0, -0.8]
};
